import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { locationService } from "@project/services/admin/location.service";
import type { City } from "@project/types/location";

const fields: Field[] = [
  {
    name: "district",
    label: "District",
    required: true,
    showInTable: true,
    lookup: { table: "districts", labelField: "name" },
  },
  {
    name: "name",
    label: "City Name",
    required: true,
    showInTable: true,
    placeholder: "Ahmedabad",
  },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
];

export default function Page() {
  return (
    <AdminShell title="Cities" subtitle="Manage cities linked to districts">
      <ApiResourceTable<City>
        title="City"
        fields={fields}
        searchFields={["name"]}
        defaultValues={{ is_active: true }}
        lookupSearchLoaders={{
          district: async query => {
            const result = await locationService.listDistrictsPage({
              page: 1,
              page_size: 50,
              search: query || undefined,
            });
            return result.data.map(d => ({
              value: String(d.id),
              label: d.name,
            }));
          },
        }}
        list={query => locationService.listCitiesPage(query)}
        create={payload =>
          locationService.createCity({
            district: Number(payload.district),
            name: String(payload.name),
            is_active: Boolean(payload.is_active),
          })
        }
        update={(id, payload) =>
          locationService.updateCity(id, {
            district:
              payload.district !== undefined
                ? Number(payload.district)
                : undefined,
            name: payload.name !== undefined ? String(payload.name) : undefined,
            is_active:
              payload.is_active !== undefined
                ? Boolean(payload.is_active)
                : undefined,
          })
        }
        remove={id => locationService.deleteCity(id)}
      />
    </AdminShell>
  );
}
